import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './CustomDropdown.module.scss';
import chevron from '../../../constants/images/chevron.svg';
import {registrationCleanerActions} from "../../../store/slices/registrationCleanerSlice";
import {UIActions} from "../../../store/slices/UISlice";

const CustomDropdown = ({type, data, defaultOption, saveData, id = null}) => {
    const [isOpenDropdown, setIsOpenDropdown] = useState(false);
    const [selectedOption, setSelectedOption] = useState(defaultOption);
    const [isDropdownFocused, setIsDropdownFocused] = useState(false);

    const {selectedCity, typeSorting} = useSelector(state => state.stepperInfo);
    const {city} = useSelector(state => state.registrationCleaner);

    const dispatch = useDispatch();

    const dropdownRef = useRef(null);

    //if the user click outside the dropdown, it closes
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpenDropdown(false);
        }
    };

    useEffect(() => {
        if (isOpenDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpenDropdown]);

    const handleSelectOption = (item) => {
        if (item !== defaultOption) {
            setSelectedOption(item);
            saveData(item);
        }

        if (type === 'cityForm') {
            dispatch(registrationCleanerActions.setCity(item));
            dispatch(UIActions.setHasDropdownError(false));
            setIsDropdownFocused(false);
        }

        setIsOpenDropdown(false);
    }

    const handleFocusOnDropdown = () => {
        if (!isDropdownFocused && !city) {
            setIsDropdownFocused(true);
            dispatch(UIActions.setHasDropdownError(true));
        }
    }

    return (
        <div
            id={id && id}
            className={styles.dropdown_wrapper}
            ref={dropdownRef}
            onClick={handleFocusOnDropdown}
        >
            <div
                onClick={() => setIsOpenDropdown(prev => !prev)}
                className={styles.dropdown_wrapper_button}
            >
                {(type === 'city' &&
                    <span>{!!selectedCity ? selectedCity : selectedOption}</span>)}

                {type === 'cityForm' &&
                    <span>{!!city ? city : selectedOption}</span>}

                {type === 'edit' &&
                    <span>{selectedOption}</span>}

                <img
                    className={styles.chevron}
                    src={chevron}
                    alt="chevron down icon"
                />
            </div>

            {isOpenDropdown &&
                <ul className={styles.dropdown_wrapper_options}>
                    {data.map((item, index) =>
                        <li
                            onClick={() => handleSelectOption(item)}
                            key={index}
                            style={{background: `${item === defaultOption ? 'rgba(204, 204, 204, 0.3)' : ''} `}}
                        >{item}</li>)}
                </ul>}
        </div>
    );
};

export default CustomDropdown;
